import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appLetters]'
})
export class lettersDirective {
  // MODIFICADO: Se añaden las vocales acentuadas y la diéresis a los caracteres permitidos.
  private allowedCharRegex: RegExp = /^[A-ZÑÁÉÍÓÚÜ.]$/;

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(): void {
    const input = this.el.nativeElement as HTMLInputElement;
    let value = input.value.toUpperCase();
    let result = '';
    let previousChar = '';

    for (const char of value) {
      // MODIFICADO: Se añade lógica para ignorar el punto si es el primer carácter.
      if (char === '.' && result.length === 0) {
        continue; // Ignora el punto al inicio y continúa con el siguiente carácter.
      }

      if (this.allowedCharRegex.test(char)) {
        result += char;
        previousChar = char;
      } else if (char === ' ' && result.length > 0 && previousChar !== ' ') {
        result += char;
        previousChar = char;
      }
    }

    if (result !== input.value) {
      input.value = result;
      input.dispatchEvent(new Event('input'));
    }
  }
}


@Directive({
  selector: '[appAlphanumeric2]'
})
export class AlphanumericDirective2 {

  // Permitirá recibir la longitud máxima desde el HTML
  @Input() appAlphanumericMaxLength: number = 0;

  // Permitirá decidir si convertimos a mayúsculas
  @Input() appAlphanumericUpperCase: boolean = false;

  constructor(private control: NgControl) { }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    let valorInicial = inputElement.value;
    let valorTransformado = valorInicial;

    // 1. Convierte a mayúsculas si se indica
    if (this.appAlphanumericUpperCase) {
      valorTransformado = valorTransformado.toUpperCase();
    }

    // 2. Remueve caracteres no permitidos en un RFC
    //    Deja pasar solo letras (incluyendo Ñ), números y el ampersand (&)
    valorTransformado = valorTransformado.replace(/[^A-Z0-9Ñ&]/g, '');

    // 3. Limita la longitud máxima si se especifica
    if (this.appAlphanumericMaxLength > 0 && valorTransformado.length > this.appAlphanumericMaxLength) {
      valorTransformado = valorTransformado.substring(0, this.appAlphanumericMaxLength);
    }

    // 4. Actualiza el valor solo si ha cambiado
    if (valorInicial !== valorTransformado) {
      this.control.control?.setValue(valorTransformado);
    }
  }
}